// metodo de validação nif e bi (algoritmo igual)
const validateBiNif = (num) => {
	if ((num != null) && (!isNaN(num)) && (num.length==9)) {
		let dC = parseInt(num.charAt(0)) * 9;

		for (let i = 2; i <= 8; i ++) {
			dC += (parseInt(num.charAt((i-1)))) * (10-i);
		}
		dC = 11 - (dC % 11);

		if (dC >= 10) {
			dC = 0;
		}
		return dC == parseInt(num.charAt(8));
	}
	return false;
}


const validateDocId = (id_doc_type, id_doc) => {
	const value = id_doc.replace(/[^0-9a-z]/ig, '');

	switch (id_doc_type.toLowerCase()) {
		case "cc":
			if (value.length != 12) {
				return false;
			}
			let secondDigit = false;
			let sum = 0;

			for (let i = value.length -1; i >= 0; i--) {
				let n = hp.helpers.getNumberFromChar(value.charAt(i));
				if (secondDigit) {
					n *= 2;
					if (n > 9) {
						n-= 9;
					}
				}
				sum += n;
				secondDigit = !secondDigit;
			}
			return ((sum % 10) == 0);

		case "bi":
			return validateBiNif(value);

		default: return true;
	}
}

const validateNiss = (niss) => {
	niss = niss.trim();

	if (isNaN(niss) || niss.length != 11) {
		return false;
	}
	if (niss == '00000000000') {
		return true;
	}
	const factors = [29, 23, 19, 17, 13, 11, 7, 5, 3, 2];
	const sum = factors.reduce((prev, value, idx) => prev + (parseInt(niss[idx]) * value), 0);

	return niss[niss.length - 1] == (9 - (sum % 10));
}

const validateNib = (nib) => {
	if(nib.length != 21 || val == null || isNaN(val)) {
		return false;
	}
	const pesos = [73, 17, 89, 38, 62, 45, 53, 15, 50, 5, 49, 34, 81, 76, 27, 90, 9, 30, 3];
	// Check Digit Calculado
	let checkDgtClc = 0;
	// Check Digit Embutido no nib
	let checkDgtEmb = nib.substr(19, 2);

	for (let i = 0; i < 19; i++) {
		checkDgtClc += parseInt(nib.charAt(i)) * pesos[i];
	}
	checkDgtClc = 98 - (checkDgtClc - parseInt(checkDgtClc / 97) * 97);

	return checkDgtEmb == checkDgtClc;
}

const validateEmail = (email) => {
	return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email)
}

const mod97 = (string) => {
	let checksum = string.slice(0, 2), fragment;
	for (let offset = 2; offset < string.length; offset += 7) {
		fragment = String(checksum) + string.substring(offset, offset + 7);
		checksum = parseInt(fragment, 10) % 97;
	}
	return checksum;
}

/*
 * Returns 1 if the IBAN is valid
 * Returns FALSE if the IBAN's length is not as should be (for PT the IBAN Should be 25 chars long starting with PT )
 * Returns any other number (checksum) when the IBAN is invalid (check digits do not match)
 */
const validateIban = (input) => {
	const CODE_LENGTHS = {
		AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
		CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
		FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
		HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
		LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
		MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
		RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26,
		AL: 28, BY: 28, CR: 22, EG: 29, GE: 22, IQ: 23, LC: 32, SC: 31, ST: 25,
		SV: 28, TL: 23, UA: 29, VA: 22, VG: 24, XK: 20
	};
	const iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, '') // keep only alphanumeric characters
	const code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/) // match and capture (1) the country code, (2) the check digits, and (3) the rest
	// check syntax and length
	if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
		return false;
	}
	// rearrange country code and check digits, and convert chars to ints
	const digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, letter => letter.charCodeAt(0) - 55)
	// final check
	return mod97(digits) === 1;
}

export {validateBiNif, validateDocId, validateNiss, validateNib, validateEmail, validateIban}
